import { render } from "./Price.vue?vue&type=template&id=c780f49c"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__